import Vue from 'vue'
import x5GMaps from 'x5-gmaps'

Vue.use(x5GMaps, { key: process.env.VUE_APP_API_MAPS, libraries: ['places'] })